import SelectAssignedGroupUser from './component';
export default SelectAssignedGroupUser;